import { Menu } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Services/AuthContext';

const AdminHeader: React.FC = () => {
  const navigate = useNavigate();
  const {logout, user} = useAuth();

  const goToSite = () => {
    navigate('/');
  };

  return (
    <nav className="navbar navbar-dark bg-dark">
      <div className="container-fluid">
        <span className="navbar-brand"> Espace Admin</span>
        <div>
          <a className="nav-link text-white d-inline-block" href="/admin/">{user?.nom}</a>
          <button onClick={goToSite} className="btn btn-sm btn-outline-light ms-3">
            Voir le site
          </button>
          <button onClick={logout} className="btn btn-sm btn-outline-danger ms-3">
            Déconnexion
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminHeader;
